/**
 * Resolves an image URL to an absolute URL pointing to the backend server.
 * This is useful for images like logos that are served directly from the backend uploads directory.
 */
export const getImageUrl = (url?: string | null): string => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
  const serverUrl = baseUrl.replace(/\/api$/, '');
  return `${serverUrl}${url.startsWith('/') ? '' : '/'}${url}`;
};
